import styled from "@emotion/styled";

export const CardInfoWrapper = styled.div(({ theme }) => ({
	alignItems: "center",
	display: "flex",
	gap: 16,
	[theme.breakpoints.down("sm")]: {
		flexDirection: "column",
		div: {
			alignSelf: "baseline"
		}
	}
}));

export const BackorderedGroup = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	lineHeight: "normal",
	alignItems: "center",
	color: theme.project.colors.semanticColors.warning,
	display: "flex",
	gap: 8,
	svg: {
		height: 20,
		width: 20
	}
}));
